// See also : src/styles/variables for CSS colors

const colors = {
  primary: "#4caf51",
  secondary: "#c7007d",
  light: "#dadee0",
  gray: "#7E7E7E",
  info: "#f3f5f7",
  warning: "#BC8E00",
  warningLight: "#FFEEBA",
  white: "#ffffff",
};

export default colors;

export enum Color {
  Primary = "primary",
  Secondary = "secondary",
}
